import LangEnum from '../../../../lang/LangEnum';
import { findSalesRepresentatives } from '../../../../services/modules/salesRepresentatives/salesRepresentatives.repository';
import type { FindSalesRepresentativesOutput } from '../../../../services/modules/salesRepresentatives/salesRepresentatives.types';
import CatalogBatchAddEntityModal from './CatalogBatchAddEntityModal';

type SalesRepItem = FindSalesRepresentativesOutput['data'][number];

interface CatalogBatchAddSalesRepsModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (ids: string[]) => void;
}

const CatalogBatchAddSalesRepsModal = ({
  open,
  onClose,
  onConfirm,
}: CatalogBatchAddSalesRepsModalProps) => (
  <CatalogBatchAddEntityModal<SalesRepItem>
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    queryKeyBase="catalog-batch-add-sales-reps"
    fetchFn={findSalesRepresentatives}
    searchParam="nameOrCode"
    defaultOrderBy={{ name: 'ASC' as const }}
    titleKey={LangEnum.CATALOGS_BULK_ADD_SALES_REPS_MODAL_TITLE}
    descriptionKey={LangEnum.CATALOGS_BULK_ADD_SALES_REPS_MODAL_DESCRIPTION}
    searchEntityKey={LangEnum.GLOBAL_SALES_REPRESENTATIVES}
    getOptionLabel={(option) => option.name}
  />
);

export default CatalogBatchAddSalesRepsModal;
